<template>
  <div class="pending-header-container">
    <div class="fiduciary-and-fiduciary-client">
      <selected-fiduciary></selected-fiduciary>
      <div class="vertical-line"></div>
      <client-selector
        :selectedText="selectedClientName"
        :canSelect="localPolicyOptions.options['select-client']"
        @onSelect="toggleClientList"
      />
    </div>
    <transition name="scale">
      <clientList
        v-show="clientListVisible"
        :fiduciary="selectedFiduciary"
        :selectedClient="selectedClient"
        @closeClientList="toggleClientList"
        @updateClientFunds="updateClient"
      />
    </transition>
    <navigation-list :items="tabs.items" :selected="selectedTab" @selectedItem="selectTab" />
    <div class="search-field-container">
      <mds-search-field
        class="search-field"
        placeholder="Search by fund name, ticker, SecID"
        label="Search"
        on-dark
        v-model="searchText"
        :disabled="!localPolicyOptions.options.search"
      >
      </mds-search-field>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash';
import { mapState } from 'vuex';
import { EventBus } from '@/utils/event-bus';
import NavigationList from '@/components/atoms/NavigationList';
import ClientList from '@/components/atoms/ClientList';
import ClientSelector from '@/components/atoms/ClientSelector';
import SelectedFiduciary from '@/components/atoms/SelectedFiduciary';
import MdsSearchField from '@mds/search-field';

export default {
  name: 'pending-header',
  components: {
    SelectedFiduciary,
    ClientList,
    ClientSelector,
    NavigationList,
    MdsSearchField,
  },
  data() {
    return {
      tabs: {
        items: [
          {
            id: 'status-changes',
            text: 'Fund Changes',
          },
          {
            id: 'lineups',
            text: 'Lineup Changes',
          },
          {
            id: 'replacements-new',
            text: '3(21) Replacements',
          },
        ],
        selected: 'status-changes',
      },
      searchText: '',
    };
  },
  watch: {
    searchText(text) {
      this.$store.dispatch('setPendingSearchTerm', text);
    },
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.pending.client.selected,
      selectedClientName: (state) => state.pending.client.name,
      clientListVisible: (state) => state.pending.client.listVisible,
      selectedTab: (state) => state.pending.tab,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to both Views
      return get(this.policies, `pending.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
  },
  created() {
    EventBus.$on('pending-search-clear', () => {
      if (!this.searchText) {
        this.$store.dispatch('setPendingSearchTerm', '');
      }
      this.searchText = '';
    });
  },
  methods: {
    toggleClientList() {
      if (this.localPolicyOptions.options['select-client']) {
        this.$store.dispatch('setPendingClientListVisible', !this.clientListVisible);
      }
    },
    updateClient(client, clientName, clientCode) {
      this.$store.dispatch('setPendingClient', {
        listVisible: false,
        name: clientName,
        code: clientCode,
        selected: client,
      });
      EventBus.$emit('pending-search-clear');
    },
    selectTab(selected) {
      this.tabs.selected = selected;
      this.$store.dispatch('setPendingTab', selected);
      this.$store.dispatch('setPendingItemsDisplayed', 0);
      this.$store.dispatch('setPendingSearchTerm', '');
    },
  },
};
</script>
<style lang="scss">
.pending-header-container {
  flex: 0 0 111px;
  position: relative;
  background-color: #12698d;
  color: $mds-color-white;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.1s ease-out;
  transform-origin: top left;
}
.scale-enter,
.scale-leave-to {
  transform: scaleY(0);
  opacity: 0;
}

.fiduciary-and-fiduciary-client {
  display: flex;
  flex-direction: row;
  line-height: 0;
}

.vertical-line {
  border-left: $mds-space-quarter-x solid $mds-background-color-white;
  margin: $mds-space-1-x 0 $mds-space-1-x 0;
}
</style>
